import { createConfig, configureChains } from 'wagmi'
import { polygon } from 'wagmi/chains'

import { alchemyProvider } from 'wagmi/providers/alchemy'
import { publicProvider } from 'wagmi/providers/public'

import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet'

export class CoinbaseService {
  client
  connector

  constructor() {
    const apiKey = process.env.REACT_APP_ALCHEMY_PROJECT_ID
    if (!apiKey) {
      return
    }

    const { chains, publicClient, webSocketPublicClient } = configureChains(
      [polygon],
      [alchemyProvider({ apiKey: apiKey as string }), publicProvider()]
    )

    const connectorCoinbase = new CoinbaseWalletConnector({
      chains,
      options: {
        appName: 'primsell.com',
        jsonRpcUrl: `https://polygon-mainnet.g.alchemy.com/v2/${apiKey}`,
      },
    })
    this.connector = connectorCoinbase

    this.client = createConfig({
      autoConnect: false,
      connectors: [connectorCoinbase],
      publicClient,
      webSocketPublicClient,
    })
  }
}
